import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marco G.',
    role: 'Allenatore Serie C — Milano, IT',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
    text: 'Il tempo di preparazione era il mio più grande stress. Con questo sistema, ho recuperato la mia vita sociale. Gli esercizi fluiscono e i miei atleti amano la varietà.'
  }, {
    name: 'Alessia L.',
    role: 'Direttrice Tecnica — Roma, IT',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80',
    text: 'Il Dizionario dei Feedback mi ha salvato la vita. Il pacchetto vale 10 volte il suo prezzo; è un punto di svolta totale per la mia carriera.'
  }];
  return <section className="bg-volley-paper py-24 px-4 sm:px-6 lg:px-8" data-id="element-219">
      <div className="max-w-5xl mx-auto" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <div className="bg-volley-navy/10 text-volley-navy-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-222">
            COSA DICONO I TUOI COLLEGHI
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight mb-4 tracking-tight" data-id="element-223">
            Testimonianze dai{' '}
            <span className="italic text-volley-orange" data-id="element-224">professionisti</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-225">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-3xl p-8 shadow-sm border border-volley-navy/5 flex flex-col hover:shadow-md transition-shadow duration-300" data-id="element-226">
              <div className="flex text-volley-yellow mb-6" data-id="element-227">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" fill="currentColor" data-id="element-228" />)}
              </div>
              <p className="text-volley-slate leading-relaxed mb-8 italic flex-1 text-lg" data-id="element-229">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-volley-gray/20" data-id="element-230">
                <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-volley-paper" loading="lazy" decoding="async" width="56" height="56" data-id="element-231" />
                <div data-id="element-232">
                  <p className="font-display font-semibold text-volley-navy text-lg" data-id="element-233">
                    {t.name}
                  </p>
                  <p className="text-volley-slate text-sm" data-id="element-234">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}